// Células ENRIQUECIDAS da lista de Templates (§4.4): canal, nº de versões e
// "plugado em". Esses campos agora vêm DIRETO na linha da listagem (o backend
// os devolve em lote) — antes cada célula buscava GET /templates/:uuid/versions,
// o que gerava um N+1 (uma chamada por linha). Componentes puros: só props.
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"

import { Badge, badgeVariants } from "@/components/ui/badge"
import { cn } from "@/lib/utils"
import type { NotificationTemplateUsedByType } from "@/types/notification-center"

const templatesPrefix =
  "pages.notificationCenter.templatesPage"

export const TemplateChannelCell = ({
  channel,
}: {
  channel?: string
}) => {
  if (!channel) return <span>—</span>
  return (
    <Badge
      variant="outline"
      className="rounded-full border font-medium"
    >
      {channel}
    </Badge>
  )
}

export const TemplateVersionsCountCell = ({
  count,
}: {
  count?: number
}) => {
  if (count === undefined || count === null)
    return <span>—</span>
  return <span className="tabular-nums">{count}</span>
}

// Chips dos eventos onde o template está plugado; vazio = badge NEUTRO
// "não associado". Cada chip LINKA para a tela de consultar já filtrada
// pelo evento (?event=<enum>), o mesmo valor que o filtro de eventos usa.
export const TemplateUsedByCell = ({
  usedBy,
}: {
  usedBy?: NotificationTemplateUsedByType[]
}) => {
  const { t } = useTranslation()
  if (!usedBy) return <span>—</span>
  if (usedBy.length === 0) {
    return (
      <Badge
        variant="outline"
        className="rounded-full border border-slate-200 bg-slate-50 font-medium text-slate-600"
      >
        {t(`${templatesPrefix}.notAssociatedBadge`)}
      </Badge>
    )
  }
  return (
    <div className="flex flex-wrap gap-1">
      {usedBy.map((usage) => (
        <Link
          key={`${usage.event}-${usage.schedulerUuid ?? "immediate"}`}
          to={`/notification-center/search?event=${usage.event}`}
          title={t(`${templatesPrefix}.usedByLinkTitle`, {
            event: usage.label,
          })}
          className={cn(
            badgeVariants({ variant: "outline" }),
            "rounded-full border border-violet-200 bg-violet-50 font-medium text-violet-700 transition-colors hover:bg-violet-100 hover:text-violet-900"
          )}
        >
          {usage.label}
        </Link>
      ))}
    </div>
  )
}
